import React from 'react';
import { theme } from '../theme';

// Componente de modal de confirmación personalizado
interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  confirmButtonColor = theme.colors.danger,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1001,
        animation: 'fadeIn 0.2s ease-out'
      }}
      onClick={handleOverlayClick}
      onKeyDown={(e) => { if (e.key === 'Escape') handleOverlayClick(e as any); }}
      role="presentation"
    >
      <div
        style={{
          backgroundColor: theme.colors.surface,
          borderRadius: theme.borderRadius.card,
          padding: theme.spacing.lg,
          maxWidth: '400px',
          width: '90%',
          boxShadow: theme.colors.shadow,
          border: `2px solid ${theme.colors.primary}`
        }}
      >
        <div style={{ marginBottom: theme.spacing.md }}>
          <h3 style={{
            margin: '0 0 12px 0',
            fontSize: theme.fonts.sizeSubtitle,
            fontWeight: theme.fonts.weightBold,
            color: theme.colors.primary,
            fontFamily: theme.fonts.heading,
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing.sm
          }}>
            <span style={{ fontSize: '20px' }}>❓</span>
            {title}
          </h3>
          <p style={{
            margin: 0,
            fontSize: theme.fonts.sizeBody,
            color: theme.colors.textSecondary,
            lineHeight: '1.5',
            fontFamily: theme.fonts.body
          }}>
            {message}
          </p>
        </div>
        <div style={{
          display: 'flex',
          gap: theme.spacing.sm,
          justifyContent: 'flex-end',
          marginTop: theme.spacing.md
        }}>
          <button
            onClick={onCancel}
            style={{
              padding: `${theme.spacing.sm} ${theme.spacing.md}`,
              backgroundColor: theme.colors.secondary,
              color: theme.colors.white,
              border: 'none',
              borderRadius: theme.borderRadius.button,
              fontSize: theme.fonts.sizeBody,
              fontFamily: theme.fonts.body,
              fontWeight: theme.fonts.weightBold,
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: `${theme.spacing.sm} ${theme.spacing.md}`,
              backgroundColor: confirmButtonColor,
              color: theme.colors.white,
              border: 'none',
              borderRadius: theme.borderRadius.button,
              fontSize: theme.fonts.sizeBody,
              fontFamily: theme.fonts.body,
              fontWeight: theme.fonts.weightBold,
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}; 